import { render, staticRenderFns } from "./kadr_field_total.vue?vue&type=template&id=de51ceb8&scoped=true&"
import script from "./kadr_field_total.vue?vue&type=script&lang=js&"
export * from "./kadr_field_total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de51ceb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de51ceb8')) {
      api.createRecord('de51ceb8', component.options)
    } else {
      api.reload('de51ceb8', component.options)
    }
    module.hot.accept("./kadr_field_total.vue?vue&type=template&id=de51ceb8&scoped=true&", function () {
      api.rerender('de51ceb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/body/addon/kadru/kadr_field_total.vue"
export default component.exports